import { styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";

const CustomInputLabel = styled('label')({
  '& .last-char': {
    color: 'red', // Son karakterin rengi
  },
});

const CustomDatePicker = ({ label, slotProps, ...props }:any) => {
  const styledLabel = (
    <CustomInputLabel>
      {label.slice(0, -1)}
      <span className="last-char">{label.slice(-1)}</span>
    </CustomInputLabel>
  );

  return (
    <DatePicker
      {...props}
      label={styledLabel}
      slotProps={{
        ...slotProps,
        textField: {
          ...slotProps?.textField,
          size: "small",
          
        },
      }}
    />
  );
};

export default CustomDatePicker;